import React from 'react';
import {
  EVENT_WIDGET_LAYOUT_TYPE_V2,
  EventWidgetDetailV2,
  EventWidgetRequestPayloadV2,
  WIDGET_TYPE_V2,
} from '../../../../../types/widget';
import EventWidgetForm from './EventWidgetForm';

export interface EventWidgetFormWrapperProps {
  isEdit: boolean;
  initialValue?: EventWidgetDetailV2;
  onChangeType: (type: WIDGET_TYPE_V2) => void;
  onFinish: (value: EventWidgetRequestPayloadV2) => void;
}

const EventWidgetFormWrapper = (props: EventWidgetFormWrapperProps): JSX.Element => {
  const { initialValue, isEdit, onFinish, onChangeType } = props;

  const formInitialValue = {
    type: WIDGET_TYPE_V2.EVENT,
    layoutType: EVENT_WIDGET_LAYOUT_TYPE_V2.SWIPE,
    ...(initialValue || {}),
  };

  return (
    <EventWidgetForm initialValue={formInitialValue} onChangeType={onChangeType} onFinish={onFinish} isEdit={isEdit} />
  );
};

export default EventWidgetFormWrapper;
